import React, { useState, useEffect, useRef } from "react";
import ModifyRecipient from "./ModifyRecipient";
import Utils from "../../../utils";
import { getRecipientList, recipientDetail } from "../../../services/Recipients";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import DeleteRecipient from "./Delete";
import Recipientsimport from "./Recipientsimport";
import "./Recipients.css";

const lengths = Utils.tableShowLengths();

function Recipients() {
    const addButtonRef = useRef(null);
    const delButtonRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [isLoad, setIsLoad] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [isEffect, setIsEffect] = useState(false);
    const [list, setList] = useState([]);
    const [totalRecipient, setTotalRecipient] = useState(0);
    const [delId, setDelId] = useState(0);
    const [data, setData] = useState({
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
        country_id: 227,
        mobile: '',
        company_name: '',
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        address_country_id: '',
        zipcode: '',
        readonly: false
    });

    // Helper function to highlight searched text
    const highlightText = (text, searchTerm) => {
        if (!searchTerm || !text) return text;

        const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
        const parts = text.toString().split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span key={index} className="search-highlight">{part}</span>
            ) : (
                part
            )
        );
    };

    useEffect(() => {
        if (isLoad) {
            setLoading(true);
        }

        setList([]);
        let obj = {
            limit: limit,
            search: search,
            page: page
        };
        getRecipientList(obj)
            .then(response => {
                if (response.data) {
                    setTotalRecipient(parseInt(response.data.count));
                    setList(response.data.data);

                }
                setLoading(false);
                setIsLoad(false);
            })
            .catch(err => {
                setLoading(false);
                setIsLoad(false);
                toast.error(Utils.getErrorMessage(err));
            });
    }, [limit, search, page, isEffect, isLoad]);

    const handleTableLength = (e) => {
        setPage(1);
        setLimit(parseInt(e.target.value));
    };

    const handleSearch = (e) => {
        setPage(1);
        setSearch(e.target.value);
    };

    const onEditRecipient = (e, data) => {
        e.preventDefault();
        setLoading(true);
        recipientDetail({ id: data.id })
            .then(response => {
                let detail = response.data.data;
                let obj = {
                    id: detail.id,
                    first_name: detail.first_name,
                    last_name: detail.last_name,
                    email: detail.email,
                    country_id: detail.country_id,
                    mobile: detail.mobile,
                    company_name: (detail.company_name) ? detail.company_name : '',
                    address_1: (detail.address_1) ? detail.address_1 : '',
                    address_2: (detail.address_2) ? detail.address_2 : '',
                    city: (detail.city) ? detail.city : '',
                    state: (detail.state) ? detail.state : '',
                    address_country_id: (detail.address_country_id) ? detail.address_country_id : '',
                    zipcode: (detail.zip_code) ? detail.zip_code : '',
                    readonly: false
                };
                setData(obj);
                addButtonRef.current?.click();
                setLoading(false);
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(true);
            });
    };

    const onViewRecipient = (e, data) => {
        e.preventDefault();
        setLoading(true);
        recipientDetail({ id: data.id })
            .then(response => {
                let detail = response.data.data;
                let obj = {
                    id: detail.id,
                    first_name: detail.first_name,
                    last_name: detail.last_name,
                    email: detail.email,
                    country_id: detail.country_id,
                    mobile: detail.mobile,
                    company_name: (detail.company_name) ? detail.company_name : '',
                    address_1: (detail.address_1) ? detail.address_1 : '',
                    address_2: (detail.address_2) ? detail.address_2 : '',
                    city: (detail.city) ? detail.city : '',
                    state: (detail.state) ? detail.state : '',
                    address_country_id: (detail.address_country_id) ? detail.address_country_id : '',
                    zipcode: (detail.zip_code) ? detail.zip_code : '',
                    readonly: true
                };
                setData(obj);
                addButtonRef.current?.click();
                setLoading(false);
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(true);
            });
    };

    const onDeleteRecipient = (e, data) => {
        e.preventDefault();
        delButtonRef.current?.click();
        setDelId(data.id);
    };

    return (
        <>
            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" />
            </div>}
            <section className="main_wrapper section-bg-color recipient_page"
                style={{ minHeight: 'calc(100vh)' }}>
                <div className="custom_container">
                    {/* Page Header & Actions Container */}
                    <div className="recipients-header-container">
                        <div className="recipients-page-header">
                            <h1 className="recipients-title">Collaborator</h1>
                            <p className="recipients-subtitle">Manage your collaborator list and contacts</p>
                        </div>

                        {/* Search and Actions Bar */}
                        <div className="recipients-actions-bar">
                            <div className="search-section">
                                <div className="search-input-wrapper">
                                    <input
                                        className="form-control search-input"
                                        type="text"
                                        value={search}
                                        onChange={handleSearch}
                                        placeholder="Search Collaborators"
                                    />
                                    <span className="search-icon">
                                        <i className="bi bi-search" />
                                    </span>
                                </div>
                            </div>
                            <div className="actions-section">
                                <div className="import-section">
                                    <Recipientsimport setIsEffect={setIsEffect} className="text-white" />
                                </div>
                                <button
                                    type="button"
                                    className="add-recipient-btn"
                                    ref={addButtonRef}
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#addRecipients"
                                    aria-controls="addRecipients"
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    title="click me to create recipients"
                                    data-bs-original-title="click Me">
                                    <span className="btn-icon text-white">+</span>
                                    Add Collaborator
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Recipients Table */}
                    <div className="recipients-table-container">
                        <div className="table-responsive rounded" style={{ minHeight: '300px', overflowX: 'auto' }} role="tabpanel">
                            <table className="table recipients-table rounded" style={{ minWidth: "1100px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ minWidth: '150px' }}>Created</th>
                                        <th style={{ minWidth: '200px' }}>Name</th>
                                        <th style={{ minWidth: '250px' }}>Email</th>
                                        <th style={{ minWidth: '150px' }}>Mobile</th>
                                        <th style={{ minWidth: '180px' }}>Company</th>
                                        <th style={{ minWidth: '150px' }}>User</th>
                                        <th style={{ minWidth: '60px' }}><i className="bi bi-three-dots-vertical" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.length > 0 ? (
                                        list.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td className="created-date" style={{ whiteSpace: 'nowrap' }}>
                                                        {highlightText(item.created_at, search)}
                                                    </td>
                                                    <td className="recipient-name" style={{ whiteSpace: 'nowrap' }}>
                                                        {highlightText(item.first_name + ' ' + item.last_name, search)}
                                                    </td>
                                                    <td className="recipient-email" style={{ whiteSpace: 'nowrap' }}>
                                                        {highlightText(item.email, search)}
                                                    </td>
                                                    <td className="recipient-mobile" style={{ whiteSpace: 'nowrap' }}>
                                                        {item.mobile ? highlightText('+' + item.country_code + ' ' + item.mobile, search) : '-'}
                                                    </td>
                                                    <td className="recipient-company" style={{ whiteSpace: 'nowrap' }}>
                                                        {item.company_name ? highlightText(item.company_name, search) : '-'}
                                                    </td>
                                                    <td className="recipient-user" style={{ whiteSpace: 'nowrap' }}>
                                                        {highlightText(item.user_by, search)}
                                                    </td>
                                                    <td className="recipient-actions">
                                                        <div className="dropdown">
                                                            <button 
                                                                className="btn p-0 border-0" 
                                                                type="button" 
                                                                data-bs-toggle="dropdown" 
                                                                aria-expanded="false"
                                                                // --- FIXED: ADDED CONFIG TO FIX DROPDOWN IN SCROLLABLE DIV ---
                                                                data-bs-popper-config='{"strategy":"fixed"}' 
                                                            >
                                                                <span style={{ cursor: 'pointer' }}>
                                                                    <i className="bi bi-three-dots-vertical" ></i>
                                                                </span>
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li>
                                                                    <button className="dropdown-item" onClick={(e) => onViewRecipient(e, item)}>
                                                                        <i className="bi bi-eye me-1"></i>View
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button className="dropdown-item" onClick={(e) => onEditRecipient(e, item)}>
                                                                        <i className="bi bi-pencil-fill me-1"></i>Edit
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button className="dropdown-item text-danger" onClick={(e) => onDeleteRecipient(e, item)}>
                                                                        <i className="bi bi-trash me-1"></i>Delete
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={7} className="text-center no-data py-4">
                                                <i className="bi bi-people fs-3 d-block mb-2 text-muted"></i>
                                                <span className="text-muted">No collaborators found</span>
                                            </td>
                                        </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {totalRecipient > 10 && (
                        <div className="table_footer_wrap my-3">
                            <div className="d-flex align-items-center">
                                <span className="me-2 text-white">Show</span>
                                <select
                                    className="form-select"
                                    value={limit}
                                    style={{ width: "80px" }}
                                    onChange={handleTableLength}
                                    aria-label="Default select example"
                                >
                                    {lengths &&
                                        lengths.map((item, i) => (
                                            <option value={item} key={i}>
                                                {item}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            <div className="pagination mb-4">
                                <Pagination
                                    activePage={page}
                                    itemsCountPerPage={limit}
                                    totalItemsCount={totalRecipient}
                                    pageRangeDisplayed={5}
                                    onChange={(e) => setPage(e)}
                                />
                            </div>
                        </div>
                    )}

                </div>

                <ModifyRecipient
                    data={data}
                    isEffect={isEffect}
                    setIsEffect={setIsEffect}
                    setData={setData}
                    setLoading={setLoading}
                />
            </section>

            <button type="button" ref={delButtonRef} className="btn btn-primary d-none" data-bs-toggle="modal"
                data-bs-target="#deleteModal" />
            <DeleteRecipient delId={delId} setDelId={setDelId} isEffect={isEffect} setIsEffect={setIsEffect} />
        </>
    )
}

export default Recipients;